import React from "react";
/* import Swiper from 'swiper';
import 'swiper/css'; */
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { GalleryContainer, MainContainer } from "./Gallery.styles";

const Gallery = ({images}) => {

  return (
    <MainContainer>
      <GalleryContainer>
        <ImageGallery items={images} />
      </GalleryContainer>
    </MainContainer>
  );
};

export default Gallery;
